$(document).ready(() => {

  // RECYCLINTIME-RENEW -- REPLACE ENTIRE DOC
  // BAS-PRESETBUILD - page blocking
  //https://keepyourcadence.com/products/the-bestseller-bundle?preview_theme_id=124232073301
  let parameter_data = deparam(window.location.href.replace('?','?&'))
  if (parameter_data['isPresetBuild']) {
    $('body').addClass('unloading');
  }

  const isBaSPage = $('html').hasClass('page-build_a_system_new')
  const isLifeproofPage = $('html').hasClass('page-lifeproof_flow')
  if (!isBaSPage && !isLifeproofPage) return;

  let editedCapsuleIndex = 0
  const confirmDeleteTitle = 'Are you sure you want to delete?'
  const confirmDeleteCopy = 'You can edit to change color, label, and size.'
  const confirmDuplicateTitle ='Confirm duplication of capsule “*label*”'
  const defaultColor = 'Sand'
  let selectedLabels = []
  let activeLabelsFilter = ''
  const defaultVariantDiscount = 5
  const largeVariantDiscount = 10
  const addToCartButtonText = "Add to Cart"
  const EditButtonText = "Update"
  let isEdit = false
  let isDebug = false

  let cartRetrieved = false
  let currentCartTotal = 0

  if(parameter_data['fix']){
    isDebug = true
  }

  // BAS-PRESETBUILD - variable
  let isPresetBuild = false

  const extenderName = "Extender"
  const tileName = "Tile"
  const smallSizeName = "Small"
  const mediumSizeName = "Medium"
  const largeSizeName = "Large"
  const smallDiscountText = "From $150 (+ up to 20% off)"
  const bigDiscountText = "From $200 (+ up to 30% off)"
  const priceToMaxDiscount = 200
  let startedBuilding = false
  let currentlyCheckingStock = false
  let updateDiscountProgressBarLoading = false
  const previewLoadingDelay = 3000 // specified in the task
  const firstPreviewPositions = [
    [0, 1],
    [2, 1],
    [0, 0],
    [2, 0],
    [1, 0],
    [1, 2],
    [3, 1],
  ]
  const listPositions = [
    [1],
    [2, 1],
    [2, 1, 3],
    [3, 2, 4, 1],
    [3, 2, 5, 1, 4],
    [3, 2, 6, 1, 5, 4],
    [3, 2, 7, 1, 6, 4, 5]
  ]

  const disabledColorSizeArray = bas_color_availability['disabled'];
  const outofStockColorArray   = bas_color_availability['outofstock'];

  const preferentialMapping = {
    "Eucalyptus": "medium",
    "Lavender": "medium",
    "Pacific": "medium",
  }
  const sizeByLabel = {
    "Small": 1,
    "Medium": 2,
    "Large": 3,
  }



  const renewRandomImages = {
    "top": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew_53eb1c71-730c-4ae7-9023-dcaac1af0d6a_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew-1_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew-2_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew-3_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew-4_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew-5_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_TOPDOWN_-Renew-6_x1000.png",
    ],
    "small": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_2_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_3_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_4_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_5_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_6_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_M_-Renew_7_x1000.png",
    ],
    "medium": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_2_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_3_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_4_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_5_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_6_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_MM_-Renew_7_x1000.png",
    ],
    "large": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_2_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_3_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_4_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_5_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_6_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_7_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/BAS_SIDE_L_-Renew_8_x1000.png",
    ]
  }


  const renewRandomImagesDynamicPreview = [
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B1.png",
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B2.png",
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B3.png",
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B4.png",
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B5.png",
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B6.png",
    "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/EARTH_DAY_B7.png"
  ]
  
  //TODO: THIS CAN BE CONSOLIDATED STRAIGHT INTO THE METAOBJECTS, FOR NOW WE'LL KEEP IT HERE
  const pearlRandomImages = {
    "top": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/PEARL_BYS_TOP_B_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/PEARL_BYS_TOP_B_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/PEARL_BYS_TOP_B_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/PEARL_BYS_TOP_B_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/PEARL_BYS_TOP_B_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/PEARL_BYS_TOP_B_06_x1000.png",
    ],
    "small": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__SMALL_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__SMALL_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__SMALL_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__SMALL_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__SMALL_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__SMALL_06_x1000.png",
    ],
    "medium": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__MEDIUM_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__MEDIUM_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__MEDIUM_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__MEDIUM_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__MEDIUM_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__MEDIUM_06_x1000.png",
    ],
    "large": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__LARGE_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__LARGE_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__LARGE_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__LARGE_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__LARGE_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/build-a-system-c37-s__LARGE_06_x1000.png",
    ]
  }

  //TODO: THIS CAN BE CONSOLIDATED STRAIGHT INTO THE METAOBJECTS, FOR NOW WE'LL KEEP IT HERE
  const graniteRandomImages = {
    "top": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_TOP_B_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_TOP_B_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_TOP_B_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_TOP_B_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_TOP_B_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_TOP_B_06_x1000.png",
    ],
    "small": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_SMALL_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_SMALL_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_SMALL_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_SMALL_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_SMALL_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_SMALL_06_x1000.png",
    ],
    "medium": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_MEDIUM_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_MEDIUM_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_MEDIUM_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_MEDIUM_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_MEDIUM_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_MEDIUM_06_x1000.png",
    ],
    "large": [
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_LARGE_01_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_LARGE_02_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_LARGE_03_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_LARGE_04_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_LARGE_05_x1000.png",
      "https://cdn.shopify.com/s/files/1/0247/7326/3445/files/GRANITE_BYS_LARGE_06_x1000.png",
    ]
  }


  const reviewPositions = [0, 2, 2, 2, 2, 2 ,2]

  const labelType = "label-value";
  const initializeBaSLabelsObject = {
    ...initializeLabelsObject,
    openOnFocus: false,
    onDropdownOpen: function() {
      if (this.$input.data('type') === labelType) {
        this.clear()
      }
    },
    onFocus: function() {
      this.close();
    },
    onType: function (str) {
      // EMOJIMOVIE
      if (/[^\u0000-\u007F]+/g.test(str)) { // regex to check if str contains non-ASCII characters (including emojis)
          this.setTextboxValue(str.replace(/[^\u0000-\u007F]+/g, '')); // remove the emoji from the input
      }
      if (str.length >= 1) {
        this.open();
      } else {
        this.close();
      }
    }
  }
  $('[bas-search-label-selectizeBaS]').selectize(initializeBaSLabelsObject)
  window.addBaSLabel = (value, $input) => {
    if (!value) return

    const isCustomize = $input.closest('.label-inner').find('.selectize-input .user-created-tag').length
    const label = isCustomize ? '' : value
    const customLabel = isCustomize ? value : ''
    if ($input.closest('.current-item').length) {
      return setCurrentItemLabel(label, customLabel)
    }
    const size = sizeByLabelObject[label]?.toLocaleLowerCase() ?? 'Medium'
    addCapsule(label.trim(), customLabel.trim(), defaultColor, size)
  }

  BaSStartLabels.forEach((label) => addCapsule(label.trim(), '', defaultColor, sizeByLabelObject[label].toLocaleLowerCase() ?? 'Medium'))

  function showPreSelectedLabel() {
    $('.label-list-item').each((i, item) => {
      const label = $(item).data('label-name')
      if (BaSMostPopularLabels.includes(label)) {
        $(item).find('.label-image-star').addClass('active')
      }
    })
  }
  showPreSelectedLabel()

  function moveSectionsToFaq() {
    const $calculator = $('#capsule-calculator-BaS').closest('.shopify-section')
    $('.faq-section-capsule-calculator-BaS').append($calculator) 
  }

  moveSectionsToFaq()

  function checkQuantity() {
    $('.label-list-item').each((i, item) => {
      count = $(item).find('.count').text()
      if (Number(count) === 0) {
        $(item).find('.label-list-button').addClass('active')
        $(item).find('.label-list-item-text').removeClass('active')
        return
      }
      $(item).find('.label-list-button').removeClass('active')
      $(item).find('.label-list-item-text').addClass('active')
    })
  }

  // DEVTODO-259
  /* OUTOFSTONK */
  function validateProductAvailability(){
    
    //skip this if the building has not started or if we're currently checking the returns
    if (!startedBuilding || currentlyCheckingStock) return

    currentlyCheckingStock = true
    // console.log('validating out of stock per capsule');
    const items = $('.bas-review-item:not(.add-another-capsule)')
    $(`.size-select-item.disabled`).removeClass('disabled').removeClass('outofstock');
    $(`.size-select-item.outofstock`).removeClass('disabled').removeClass('outofstock');
    items.map((i, el) => {
      const index = $(el).data('item-index');
      
      const {isCustomize, label, customizeLabel, size, color} = getPropertiesHelper(index)
      // console.log('=============checking stock for index=====', index, 'for color and size', color, size);

      if (color in disabledColorSizeArray || color in outofStockColorArray){
        // console.log('color is disabled or out of stock', color, 'current SELECTED size is', size);
        
        //check if the current size is allowed or not
        var sizeForbidden = false;
        if (disabledColorSizeArray[color]?.includes(size) || outofStockColorArray[color]?.includes(size)){
          // console.log('current size is disabled', size);
          sizeForbidden = true;
        }

        var newSize = 'Medium';
        for (var key in sizeByLabel){
          if (!disabledColorSizeArray[color]?.includes(key) && !outofStockColorArray[color]?.includes(key)){
            // console.log('newSize for color', color, newSize);
            newSize = key;
          }
        }

        //update to default Size
        // console.log('current size vs newSize', size, newSize);
        if (sizeForbidden && newSize !== size){
          newSize = newSize.toLowerCase();
          // console.log('UPDATING newSize for color', color, newSize);
          $(`.size-list-item[data-item-index="${index}"] input[value="${newSize}"]`).prop('checked', true).change()
        }

        for (var key in sizeByLabel){
          // console.log('checking size', color, key, sizeByLabel[key]);
          if (disabledColorSizeArray[color]?.includes(key)){
            // console.log('size is disabled');
            $(`label[for="size-select${sizeByLabel[key]}_0_${index}"]`).addClass('disabled outofstock');
          }else if (outofStockColorArray[color]?.includes(key)){
            // console.log('size is out of stock');
            $(`label[for="size-select${sizeByLabel[key]}_0_${index}"]`).addClass('outofstock');
          }
        }
      }
    })
    currentlyCheckingStock = false
    
    //KLAVIYO TRACKING FOR EVENTS
    if (typeof item !== 'undefined') {
      item.URL = saveBaSToUrl();
      //format price with cents
      var curPrice = calculatePrice();
      item.Price = '$'+curPrice.toFixed(2);
      item.$value = curPrice;
      var _learnq = _learnq || []; 
      _learnq.push(['track', 'Viewed Product', item]);
      _learnq.push(['trackViewedItem', {
        Title: item.Name || '',
        ItemId: item.ProductID || '',
        Categories: item.Categories || [],
        ImageUrl: item.ImageURL || '',
        Url: item.URL || '',
        Metadata: {
          Brand: item.Brand || '',
          Price: item.Price || 0,
          CompareAtPrice: item.CompareAtPrice || 0
        }
      }]);
    }
  }

  $('.button-start-building').click((e) => {


    if ($(e.currentTarget).hasClass('disabled')) return

    var curPrice = calculatePrice()
    juni_event('bas-step1-labels', curPrice, curPrice);

    const labelTab = $('.bas-label-tab')
    labelTab.removeClass('disabled')
    labelTab.find('.expand-trigger').click()
    $('.product-content > .copy, .product-content > .main-preview-container, .product-content > .button-start-building').hide()
    $('.sticky-button').html(labelTab.find('.next-step-button').html())
    $('.main-preview-container .new-bas-animation-content ').hide()
    startedBuilding = true
  })
  // BAS-PRESETBUILD -- set default size for medium when capsule size is not predefined
  // set default size as medium for when a predefined size is not set in the metafields
  $('.label-list-wrapper').on('click', '.label-list-item .label-list-button', (e) => {
    
    const label = $(e.currentTarget).closest('.label-list-item').data('label-name')
    // const size = sizeByLabelObject[label].toLocaleLowerCase()
    const size = sizeByLabelObject[label]?.toLocaleLowerCase() ?? 'Medium';
    addCapsule(label, '', defaultColor, size)
    juni_event('bas-add-label', label, calculatePrice());
  })

  $('.label-list-wrapper').on('click', '.label-list-item .plus', (e) => {
    const label = $(e.currentTarget).closest('.label-list-item').data('label-name')
    // const size = sizeByLabelObject[label].toLocaleLowerCase()
    const size = sizeByLabelObject[label]?.toLocaleLowerCase() ?? 'Medium';
    addCapsule(label, '', defaultColor, size)
    juni_event('bas-add-label-plus', label, calculatePrice());
  })
  $('.label-list-wrapper').on('click', '.label-list-item .minus', (e) => {
    const label = $(e.currentTarget).closest('.label-list-item').data('label-name')
    juni_event('bas-remove-label', label, calculatePrice());
    removeCapsule(label)
  })
  $('.custom-label-list-wrapper').on('click', '.custom-label-item .remove', (e) => {
    const customLabel = $(e.currentTarget).closest('.custom-label-item').data('label-name')
    removeCapsule(customLabel, true)
  })

  $('.next-step-button').click((e) => {
    
    if ($(e.currentTarget).hasClass('add-to-cart') || $(e.currentTarget).hasClass('disabled')) return
    
    const wrapper = $(e.target).closest('.expand-wrapper')
    const nextWrapper = wrapper.next()

    //juni
    var curPrice = calculatePrice()

    wrapper.find('.expand-trigger').removeClass('active')
    wrapper.find('.expand-content').slideUp(500)
    wrapper.addClass('completed')
    if (nextWrapper.hasClass('bas-review-tab')){
      nextWrapper.show()
      juni_event('bas-step4-review', curPrice, curPrice);
    } 
    if (nextWrapper.hasClass('bas-color-tab')){
      juni_event('bas-step2-colors', curPrice, curPrice);
      validateProductAvailability()
    } 
    if (nextWrapper.hasClass('expand-wrapper')) {
      nextWrapper.removeClass('disabled')
      nextWrapper.find('.expand-trigger').addClass('active')
      nextWrapper.addClass('active').find('.expand-content').slideDown(500)
    }
    if (nextWrapper.hasClass('bas-size-tab')) {
      $('.dynamic-bundling-wrapper').addClass('loading').delay(previewLoadingDelay).queue((next) => {
        $('.dynamic-bundling-wrapper').removeClass('loading')
        next();
      });
      juni_event('bas-step3-size', curPrice, curPrice);
    }
    $('.sticky-button').html(nextWrapper.find('.next-step-button').html())

  })


  $('.product-content .expand-trigger').click((e) => {
    
    const curEl = $(e.currentTarget)
    if (curEl.parent().hasClass('disabled')) return

    $('.product-content .expand-trigger').not(curEl).removeClass('active').parent().find('.expand-content').hide()
    $('.sticky-button').html($(e.target).closest('.expand-wrapper').find('.next-step-button').html())
    
    //if the current element doesnt have the class "active"
    if (startedBuilding && curEl.hasClass('active') === false){
      var next_step = curEl.parent().hasClass('bas-label-tab') ? 'bas-step1-labels' : curEl.parent().hasClass('bas-color-tab') ? 'bas-step2-colors' : curEl.parent().hasClass('bas-size-tab') ? 'bas-step3-size' : 'bas-step4-review';
      juni_event("bas-reload", next_step);
    }

  })

  $('.bas-color-tab').on('change', '.color-list-item input', (e) => {
    
    
    const curEl = $(e.currentTarget)
    const curParrentEl = curEl.closest('.color-list-item')
    const value = curEl.val()
    const colorIndex = bundleColorValues.indexOf(value) + 1
    const itemIndex = curParrentEl.data('item-index')

    if (startedBuilding){
      juni_event('bas-color-change', value);
    }    
    
    // add the badge logic
    curParrentEl.find('.title .color-limited-edition').remove()
    if(master_color_list[value]?.['badge_text'] != ''){
      // curParrentEl.find('.title .color').text(value+' (Limited Edition NEW)')
      //add this html element to the item
      // <span class="color-limited-edition terracotta-solid">Limited Edition</span>
      curParrentEl.find('.title .color').text(value)
      curParrentEl.find('.title .color').append(`<span class="color-limited-edition terracotta-solid">${master_color_list[value]['badge_text']}</span>`)
    }else{
      curParrentEl.find('.title .color').text(value)
    }

    const sizeEl = $(`.bas-size-tab .size-list-item[data-item-index="${itemIndex}"]`)
    const index = Number($('.index', curParrentEl).data('index'))
    const container = $('.bas-tiles-preview-container')
    scrollToInContainer(container, '.bas-tiles-preview-item', index)

    sizeEl.find('.title .color').text(value)
    sizeEl.find('img').each((i, el) => {
      const src = $(el).attr('src').replace(/&capsules=(.*?)&size=/, `&capsules=${colorIndex}&size=`)
      $(el).attr('src', src)
    })
    $(`.bas-review-tab .bas-review-item[data-item-index="${itemIndex}"] .color`).text(value)
    validateProductAvailability()
    updateSizeTooltip(itemIndex)
    generateDynamicBundleImage()
    updateTilesPreview()
    saveBaSToSession()
  })

  $('.bas-size-tab').on('change', '.size-list-item  input', (e) => {
    const curEl = $(e.currentTarget)
    const valueOz = curEl.data('oz')
    // const valueOz = 'hello'
    var valueOzNew = valueOz;
    if(valueOz == '0.56 oz'){
      valueOzNew = 'Small';
    }else if(valueOz == '1.32 oz'){
      valueOzNew = 'Medium';
    }else if(valueOz == '2.75 oz'){
      valueOzNew = 'Large';
    }
    const curParrentEl = curEl.closest('.size-list-item')
    const itemIndex = curParrentEl.data('item-index')
    const index = Number($('.index', curParrentEl).data('index'))
    const container = $('.dynamic-bundling-wrapper')
    scrollToInContainer(container, '.group', index)
    curParrentEl.find('.title .size').text(valueOzNew)
    $(`.bas-review-tab .bas-review-item[data-item-index="${itemIndex}"] .size`).text(valueOzNew)
    $('.dynamic-bundling-wrapper').removeClass('loading')
    validateProductAvailability()
    updateSizeTooltip(itemIndex)
    calculatePrice()
    generateDynamicBundleImage()
    saveBaSToSession()
  })

  $('.sticky-button').click(() => {
    $('.product-content .next-step-button:visible, .product-content .button-start-building:visible').first().click()
  })
  
  $('.bas-review-tab-container').on('click', '.bas-review-item .edit', (e) => {
    const curEl = $(e.currentTarget).closest('.bas-review-item')
    editedCapsuleIndex = curEl.data('item-index')
    const titleIndex = curEl.find('.index').text()
    const { label, customLabel } = selectedLabels[editedCapsuleIndex]
    const color = $(`.color-list-item[data-item-index="${editedCapsuleIndex}"] input:checked`).val()
    const size = $(`.size-list-item[data-item-index="${editedCapsuleIndex}"] input:checked`).val()
    $('.current-item .capsule-index').text(`${titleIndex.length === 1 ? '0' : ''}${titleIndex}`)
    $(`.current-item .color-select input[value="${color}"]`).prop('checked', true).change()
    $(`.current-item .size-select input[value="${size}"]`).prop('checked', true).change()
    $('.current-item').addClass('active')
    setCurrentItemLabel(label, customLabel)
    $('body').addClass('modal-open')
    checkActiveColor(color)
    juni_event('bas-step4-edit', label, calculatePrice());
  })
  
  $('.add-another-capsule').click(() => {
    const titleIndex = $('.bas-review-item').length.toString()
    const $modal = $('.current-item')
    $('.capsule-index', $modal).text(`${titleIndex.length === 1 ? '0' : ''}${titleIndex}`)
    $('.selected-label .remove', $modal).click()
    $('.color-select-expand .colorCharcoal input', $modal).click()
    $('.label-select-expand .expand-trigger:not(.active)', $modal).click()
    $modal.addClass('active')
    $modal.addClass('is-new-capsule')
    $('body').addClass('modal-open')
  })

  $('.bas-review-tab-container').on('click', '.bas-review-item .duplicate', (e) => {
    const curEl = $(e.currentTarget).closest('.bas-review-item')
    const index = curEl.data('item-index')
    const label = selectedLabels[index].label || selectedLabels[index].customLabel
    $('.js-modal-open-bas-confirm-modal').click()
    $('#bas-confirm-modal .modal__centered-header').text(confirmDuplicateTitle.replace('*label*', label))
    $('#bas-confirm-modal .modal__centered-copy').hide()
    $('#bas-confirm-modal .modal__centered-copy').hide()
    $('#bas-confirm-modal').data('type', 'bas-v2-duplicate')
    $('#bas-confirm-modal').data('index', index)
    $('#bas-confirm-modal .btn-confirm').text('Duplicate')
    juni_event('bas-step4-duplicate', label, calculatePrice());
  })

  
  //REMOVEITTHUS
  $('.bas-review-tab-container').on('click', '.bas-review-item .remove', (e) => {
    const curEl = $(e.currentTarget).closest('.bas-review-item')
    const index = curEl.data('item-index')
    editedCapsuleIndex = index
    const label = selectedLabels[index].label || selectedLabels[index].customLabel
    $('.js-modal-open-bas-confirm-modal').click()
    $('#bas-confirm-modal .modal__centered-header').text(confirmDeleteTitle.replace('*label*', label))
    $('#bas-confirm-modal .modal__centered-copy').text(confirmDeleteCopy).show()
    $('#bas-confirm-modal').data('type', 'bas-v2-delete')
    $('#bas-confirm-modal').data('index', index)
    $('#bas-confirm-modal .btn-confirm').text('Remove')
    // $('.js-modal-open-bas-confirm-modal').click()
    // $('#bas-confirm-modal .modal__centered-header').text(confirmDeleteTitle)
    // $('#bas-confirm-modal .modal__centered-copy').text(confirmDeleteCopy).show()
    // $('#bas-confirm-modal').data('type', 'bas-v2-delete')
    // $('#bas-confirm-modal .btn-confirm').text('Remove')
    juni_event('bas-step4-remove', label, calculatePrice());
  })


  $('#bas-confirm-modal .btn-confirm').click(() => {
    const { type, index } = $('#bas-confirm-modal').data()
    if (type !== "bas-v2-duplicate") return
    
    const label = selectedLabels[index].label
    const customizeLabel = selectedLabels[index].customLabel
    const color = $(`.color-list-item[data-item-index="${index}"] input:checked`).val()
    const size = capitalizeFirstLetter($(`.size-list-item[data-item-index="${index}"] input:checked`).val())
    addCapsule(label, customizeLabel, color, size.toLowerCase())
    juni_event('bas-duplicated', label, calculatePrice());
  })

  function scrollToInContainer(containers, selector, index) {
    if (!startedBuilding) return

    containers.each((i, el) => {
      const scrollTo = $(selector, $(el)).eq(index - 1)
      const offsetToCenter = $(el).outerWidth() / 2 - scrollTo.width() / 2
      $(el).clearQueue().animate({
        scrollLeft: scrollTo.offset().left - $(el).offset().left + $(el).scrollLeft() - offsetToCenter
      }); 
    })
  }

  window.addEventListener('scroll', function() {
    $('.stickyContainer').each((i, el) => {
      const stickyMargin = 40
      const previewTop = $(el).offset().top
      const copy = $(el).prev()
      const copyTop = copy.offset().top
      const copyHeight = copy.outerHeight(true)
      const isSticky = previewTop > copyTop + copyHeight + stickyMargin
      $(el).toggleClass('sticky', isSticky)
    })
  });

  $('.add-to-cart').click(async(e) => {
    if ($('.add-to-cart').hasClass('disabled')) return
    var curPrice = calculatePrice()
    juni_event('bas-finished', 'add-to-cart', curPrice);
    let discount = BaSGetDiscount(curPrice)?.discount || 0
    const mainData = {
      items : [
        {
          id: build_a_system_new_main_id,
          quantity: 1,
          properties: getPropertiesAll()
        }
      ]
    }
    $('.add-to-cart, .sticky-button-wrapper .sticky-button').addClass('disabled')
    const items = mainData.items
    const timestamp = mainData.items[0].properties['_Timestamp'] || mainData.items[0].properties['Timestamp']
    
    $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)').map((i, el) => {
      const index = $(el).data('item-index')
      const label = selectedLabels[index].label
      const customizeLabel = selectedLabels[index].customLabel
      const color = $(`.color-list-item[data-item-index="${index}"] input:checked`).val()
      const size = capitalizeFirstLetter($(`.size-list-item[data-item-index="${index}"] input:checked`).val())
      const type = !!customizeLabel ? 'custom' : 'standard'
      const partDiscount = (() => {
        if (size === largeSizeName && discount >= largeVariantDiscount) return largeVariantDiscount
        return discount > 0 ? defaultVariantDiscount : 0
      })()
      const findOptionText = `${type} / ${size} / ${partDiscount}`
      discount = discount - partDiscount
      
      // ==================================================================
      // ============== SHADOWCAPREMOVAL ==================================
      // =============== NEW LOGIC FOR ADDING TO CART =====================
      //check if the indoptionKey is in the the array
      const findOptionKey = `${size.toLowerCase()}-${color}-${type}`
      var variant_id = capsule_variants_2[findOptionKey];
      
      // console.log('findOptionKey', findOptionKey)
      // console.log('variant_id', variant_id)

      if (variant_id){
        // const id = $(option).val()
        var properties = getPropertiesNonShadowCapsule(index, timestamp)
        // const item = existingShadowProductItem({variant_id, properties}, items)
        items.push({
          id: variant_id,
          quantity: 1,
          properties
        })
      }
      // debugger;
      //=============== NEW LOGIC FOR ADDING TO CART ======================

      // $('#ProductSelect option').toArray().find((option) => {
      //   const curOptionText = $(option).text()
      //   if (curOptionText.includes(findOptionText)) {
      //     const id = $(option).val()
      //     const properties = getPropertiesSingle(index, timestamp)
      //     const item = existingShadowProductItem({id, properties}, items)
      //     if (item) {
      //       item.quantity += 1
      //       item.properties['Quantity'] += 1
      //     }
      //     else
      //       items.push({
      //         id,
      //         quantity: 1,
      //         properties
      //       })
      //     return true
      //   }
      // })
      // addShadowProducts(items, color, label, customizeLabel, 1, timestamp, size)

    })
    // debugger;
    // Obtener todos los checkbox de accesorios

    const checkboxes = $('input.add-accessory');
    // console.log(`Se encontraron ${checkboxes.length} checkboxes.`);

    // Verificar los elementos seleccionados
    checkboxes.each(function() {
      if ($(this).is(':checked')) {
          const productId = $(this).data('product-id');
          const variantId = $(this).val();
          
          const productElement = $(`.product-addon[data-product-id="${productId}"]`);
          const productTitle = productElement.find('.product-addon__title').text();
          const productPrice = productElement.find('.product-addon__price').text();
          let productSize = productElement.find('select.addon-variant option:selected').text().trim(); 
          const productImage = productElement.find('.addon-image').attr('src');

          const exists = mainData.items.some(item => item.id === variantId);



          let newItem = {
              id: variantId,
              quantity: 1,
              properties: {
                  '_accessory': true,
                  '_addon_to': 6962709135445
              }
          };

          // Añadir al arreglo mainData.items
          mainData.items.push(newItem);
          //console.log(`Producto añadido: ${productTitle}`);
      }
  });
    // console.log(mainData.items);

    const resData = await $.post('/cart/add.js', mainData)
    if (isEdit) {
      await theme.cart.changeItem(keyOfEdit, 0)
      keyOfEdit = JSON.parse(resData).items[0].key
      return
    }
    $('body').trigger('updateCart')

    // AXXON TIME
    if (typeof axon === 'function') {
      var axonItem = window.axonItem;
      if(axonItem && curPrice){
        axonItem.quantity = 1;
        axonItem.price = curPrice;
      }
      axon('track', 'add_to_cart', 
        {
          currency: 'USD',
          value: axonItem.price * axonItem.quantity,
          items: [axonItem]
        }
        );
    }
  })

  function currentTabUpdated() {
    const currentTab = $('.product-content .expand-wrapper .expand-trigger.active').parent()
    const firstTab = $('.bas-label-tab')
    const tabHeight = isDesktop() ? 58 : 78
    const headerHeight = isDesktop() ? 141 : 0
    $('.discount-progress-wrapper').addClass('hidden')
    if (!currentTab.length) return

    $('html, body').animate({
      scrollTop: firstTab.offset().top + $('.product-content .expand-wrapper').index(currentTab) * tabHeight - headerHeight
    });
    calculatePrice()
    $('.bas-notification').hide()
    const mainPreview = $('.main-preview-container')
    $('.bas-tiles-preview-container', mainPreview).hide()
    $('.dynamic-bundling', mainPreview).hide()
    if (currentTab.hasClass('bas-label-tab') || currentTab.hasClass('bas-color-tab')) {
      if(currentTab.hasClass('bas-label-tab')) {
        $('.bas-notification.tab-label').show()
      } else {
        $('.bas-notification.tab-color').show()
      }
      return $('.bas-tiles-preview-container', mainPreview).show()
    }
    if(currentTab.hasClass('bas-review-tab')) {
      $('.discount-progress-wrapper').removeClass('hidden')
    }
    $('.bas-notification.tab-size').toggle(currentTab.hasClass('bas-size-tab'))
    $('.dynamic-bundling', mainPreview).show()
  }
  $('.product-content .expand-wrapper .expand-trigger').onClassChange(() => currentTabUpdated())
  
  function addShadowProducts(items, color, label, customLabel, quantity, timestamp, size) {
    const properties = {
      'Product': "build_a_system",
      'Color': color,
      'Label': !!customLabel ? 'customize' : label,
      'Custom Label': customLabel,
      'Quantity': quantity,
      'Parent Timestamp': timestamp,
    }
    const productType = getShadowProductType(size)
    const shadowCapsules = getShadowProduct(productType, color, size)?.id
    const item = {id: shadowCapsules, quantity, properties}
    const existingItem = existingShadowProductItem(item, items)
    if (existingItem) {
      existingItem.quantity += quantity
      existingItem.properties['Quantity'] += 1
    } else 
      items.push(item)
  }
  const getShadowProductType = (size) => {
    if (size === "Extender") return "extender"
    if (size === "Tile") return "flex_tile"
    return 'capsule'
  }

  function getPropertiesSingle (index, timestamp) {
    const data = {}
    const {isCustomize, label, customizeLabel, size, color} = getPropertiesHelper(index)
    data[`_Parent Timestamp`] = timestamp
    data[`_Custom Bundle Label`] = isCustomize ? customizeLabel : ''
    data[`_Bundle Size`] = size
    data[`_Bundle Color`] = color
    data[`_Standard Bundle Label`] = isCustomize ? 'customize' : label
    data[`_Quantity`] = 1
    return data
  }

  // === SHADOWCAPREMOVAL ====
  function getPropertiesNonShadowCapsule (index, timestamp) {
    const data = {}
    const {isCustomize, label, customizeLabel, size, color} = getPropertiesHelper(index)
    data[`_Product`] = 'build_a_system'
    data[`_Parent Timestamp`] = timestamp
    // data[`System ID`] = timestamp
    data[`_Custom Label`] = isCustomize ? customizeLabel : ''
    data[`_Size`] = size
    data[`_Color`] = color
    data[`_Label`] = isCustomize ? 'customize' : label
    data[`_Quantity`] = 1
    data[`_Index`] = index
    return data
  }
  // === SHADOWCAPREMOVAL ====


  function getPropertiesHelper(index) {
    const label = selectedLabels[index].label
    const customizeLabel = selectedLabels[index].customLabel
    const color = $(`.color-list-item[data-item-index="${index}"] input:checked`).val()
    const size = capitalizeFirstLetter($(`.size-list-item[data-item-index="${index}"] input:checked`).val())
    return {isCustomize: !!customizeLabel, label, customizeLabel, size, color}
  }
  // CHECKOUTEXTENSIBILITY
  function getPropertiesAll () {
    const data = {}
    const items = $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)')
    const price = calculatePrice()
    data[`_Timestamp`] = Date.now()
    data[`_Count of items`] = items.length
    data[`_URL For Edit`] = saveBaSToUrl()

    
    // data[`System ID`] = data[`_Timestamp`]

    //look for variable pg_loadid if it exists
    if (typeof pg_loadid !== 'undefined') {
      data[`_pageload_id`] = pg_loadid
    }
    if(typeof juni_session_id !== 'undefined') {
      data[`_session_id`] = juni_session_id
    }
    // ======= BAS-PRESETBUILD =========
    data[`_Preset Build`] = false
    if (isPresetBuild){ 
      data[`_Preset Build`] = true
      if (parameter_data['productTitle']) {
        data[`_Preset Build Title`] = parameter_data['productTitle']
      }
    }
    // ==================================
    // debugger;

    if (BaSGetDiscount(price) && !isLifeproofPage) {
      data[`_Price Without Discount`] = parseFloat(price).toFixed(2)
    }

    // this is a text summary of the capsules as a string
    // Medium Rosa (Label Text) ## Medium Rosa (Label Text) ## Medium Rosa (Label Text) ... etc
    // CUSTOMCAPSULESUMMARY
    data[`_summary`] = false
    items.map((index, el) => {
      const {isCustomize, label, customizeLabel, size, color} = getPropertiesHelper($(el).data('item-index'))
      data[`_Standard Bundle Label ${ index + 1 }`] = isCustomize ? 'customize' : label
      data[`_Custom Bundle Label ${ index + 1 }`] = isCustomize ? customizeLabel : ''
      data[`_Bundle Size ${ index + 1 }`] = size
      data[`_Bundle Color ${ index + 1 }`] = color
      //add the summary
      if (index === 0){
        data[`_summary`] = `${size} ${color} (${isCustomize ? customizeLabel : label})`
      }else{
        data[`_summary`] += `##${size} ${color} (${isCustomize ? customizeLabel : label})`
      }

    })
    return data
  }

  function saveBaSToUrl() {
    const items = $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)')
    const data = {
      isEdit: true,
      count: items.length,
      bundleLabels: [],
      bundleCustomLabels: [],
      bundleColors: [],
      bundlesizes: []
    }
    items.map((i, el) => {
      const {label, customizeLabel, size, color} = getPropertiesHelper($(el).data('item-index'))
      data.bundleLabels.push(label)
      data.bundleCustomLabels.push(customizeLabel || '')
      data.bundleColors.push(color)
      data.bundlesizes.push(size)
    })
    const { origin, pathname } = window.location
    return `${origin + pathname}?&${$.param( data )}`
  }

  function getLabelHtml(label) {
    if (isIcon(label)) {
      return $(`.bas-label-tab-container [data-label-name="${label}"] .label-name`).html().replace('-white', '-black')
    }
    return label
  }

  $('.current-item .size-select-expand input').change((e) => {
    const curEl = $(e.currentTarget)
    const valueOz = curEl.data('oz')
    $('.size-select-expand .option-name .expand-value').text(valueOz)
    calculateCurrentItemPrice()
  })

  $('.current-item .color-select-expand input').change((e) => {
    const curEl = $(e.currentTarget)
    const color = curEl.val()

    $('.color-select-expand .option-name .expand-value').text(color)
    const colorIndex = colorNames.indexOf(color)
    const labelColor = labelColors[colorIndex]
    labelItems = $('.selected-label, .label-list-item')
    $('.label-name, .label', labelItems).toggleClass('white', labelColor === 'white')
    $('.label-name  img, .label img', labelItems).each((i, el) => {
      const src = $(el).attr('src')
      $(el).attr('src', src.replace('-black', `-${labelColor}`).replace('-white', `-${labelColor}`))
    })
    updateSizesPreviews()
    calculateCurrentItemPrice()
  })

  $('.close-current-item-window').click(closeCurrentItem)

  $('.current-item').click((e) => {
    if ($(e.target).closest('.item').length) return

    closeCurrentItem(e)
  })

  $('.finish-editing').click((e) => {
    const { label, customLabel } = $('.current-item .selected-label').data()
    const color = $(`.current-item .color-select input:checked`).val()
    const size = $(`.current-item .size-select input:checked`).val()
    if ($('.current-item').hasClass('is-new-capsule')) {
      addCapsule(label, customLabel, color, size, true)
      editedCapsuleIndex = selectedLabels.length - 1
    } else {
      $(`.color-list-item[data-item-index="${editedCapsuleIndex}"] input[value="${color}"]`).prop('checked', true).change()
      $(`.size-list-item[data-item-index="${editedCapsuleIndex}"] input[value="${size}"]`).prop('checked', true).change()
    }
    updateLabelInList(editedCapsuleIndex, label, customLabel)
    closeCurrentItem()
    updateTilesPreview()
    calculatePrice()
    saveBaSToSession()
  })

  $('.filter-item').click((e) => {
    const groupName = $(e.currentTarget).text()
    activeLabelsFilter = activeLabelsFilter === groupName ? '' : groupName
    $('.bas-label-tab-container .label-list-item').show()
    if (activeLabelsFilter) {
      $('.bas-label-tab-container .label-list-item').each((i, el) => {
        if ($(el).data('group-name').toLowerCase().includes(activeLabelsFilter.toLocaleLowerCase())) return

        $(el).hide()
      })
    }
  })

  $('#bas-recommended-bundles .selected_button').click((e) => {
    // console.log('recommended bundles modal selected');
    if ($(e.currentTarget).hasClass('disabled')) return

    $('.selected_button').removeClass('disabled')
    $(e.currentTarget).addClass('disabled')
    const capsules = $(e.currentTarget).data('capsules').split('|')
    clearAll()
    capsules.forEach((el) => {
      const capsule = el.split(',') // [label,color,size]
      addCapsule(capsule[0], '', capsule[1], capsule[2])
    })
    $('#bas-recommended-bundles .js-modal-close').click()
  })

  $('.current-item .selected-label .remove').click(() => {
    $('.current-item .selected-label').hide()
    $('.current-item .label-select-wrapper').show()
    $('.current-item .finish-editing').addClass('disabled')
  })

  $('.current-item .label-select-wrapper .label-list-item').click((e) => {
    const label = $(e.currentTarget).data('label-name')
    setCurrentItemLabel(label, '')
  })

  function setCurrentItemLabel(label, customLabel) {
    const $labelSelecteExpand = $('.current-item .label-select-expand')
    const color = $(`.current-item .color-select input:checked`).val()
    const colorIndex = colorNames.indexOf(color)
    const labelColor = labelColors[colorIndex]
    const labelHtml = isIcon(label) ? getLabelHtml(label) : parseLabel(customLabel || label)
    $('.custom_label').removeClass('active')
    if (customLabel) {
      $('.custom_label').addClass('active')
    }
    $(`.expand-value`, $labelSelecteExpand).html(getLabelHtml(label || customLabel))
    $(`.selected-label`, $labelSelecteExpand).data('label', label).data('customLabel', customLabel)
    $(`.selected-label .label`, $labelSelecteExpand).html(labelHtml)
    const src = $(`.selected-label .label img`, $labelSelecteExpand).attr('src')
    src && $(`.selected-label .label img`, $labelSelecteExpand).attr('src', src.replace('-black', `-${labelColor}`).replace('-white', `-${labelColor}`))
    $('.current-item .selected-label').show()
    $('.current-item .label-select-wrapper').hide()
    $('.current-item .finish-editing').removeClass('disabled')
  }

  function clearAll() {
    $('.bas-review-item[data-item-index]').each((i, el) => {
      const index = $(el).data('item-index')
      removeCapsule('', '', index)
    })
  }

  function addCapsule(label = '', customLabel = '', color = defaultColor, size = "medium", createdFromReview = false) {
    addLabelToList(label, customLabel)
    const lastCapsuleIndex = selectedLabels.length - 1
    const reviewItem = $(`.bas-review-item-template`).clone().removeClass('bas-review-item-template').addClass('bas-review-item')
    const colorItem = $(`.color-list-item-template`).clone().removeClass('color-list-item-template').addClass('color-list-item')
    const sizeItem = $(`.size-list-item-template`).clone().removeClass('size-list-item-template').addClass('size-list-item')
    updateIndex = (i, el) => $(el).data('item-index', i).attr('data-item-index', i).find('.title .index').text(i + 1)
    updateAttr = (itemEl) => {
      itemEl.find('input').each((i, el) => $(el).attr('name', `${$(el).attr('name')}_${lastCapsuleIndex}`))
      itemEl.find('input').each((i, el) => $(el).attr('id', `${$(el).attr('id')}_${lastCapsuleIndex}`))
      itemEl.find('label').each((i, el) => $(el).attr('for', `${$(el).attr('for')}_${lastCapsuleIndex}`))
      itemEl.find('.label').html(getLabelHtml(label || customLabel))
    }
    if(customLabel){
      $('.custom-label-list-wrapper').css('display', 'flex');
    }
    updateIndex(lastCapsuleIndex, reviewItem)
    updateIndex(lastCapsuleIndex, colorItem)
    updateIndex(lastCapsuleIndex, sizeItem)
    updateAttr(reviewItem)
    updateAttr(colorItem)
    updateAttr(sizeItem)
    const itemsCount = $('.bas-review-item:not(.add-another-capsule)').length
    if (createdFromReview && itemsCount && itemsCount <= reviewPositions.length) {
      reviewItem.insertBefore($('.bas-review-item').eq(reviewPositions[itemsCount - 1]))
      colorItem.insertBefore($('.bas-color-tab-container .color-list-item').eq(reviewPositions[itemsCount - 1])).ready(function () {
        $(`.color-list-item[data-item-index="${lastCapsuleIndex}"]`).find(`input[value="${color}"]`).prop('checked', true).click().change()
      });
      sizeItem.insertBefore($('.bas-size-tab-container .size-list-item').eq(reviewPositions[itemsCount - 1])).ready(function () {
        $(`.size-list-item[data-item-index="${lastCapsuleIndex}"]`).find(`input[value="${size}"]`).prop('checked', true).click().change()
      });
    } else {
      reviewItem.insertBefore($('.bas-review-item.add-another-capsule'))
      $('.bas-color-tab-container').append(colorItem).ready(function () {
        $(`.color-list-item[data-item-index="${lastCapsuleIndex}"]`).find(`input[value="${color}"]`).prop('checked', true).click().change()
      });
      $('.bas-size-tab-container').append(sizeItem).ready(function () {
        $(`.size-list-item[data-item-index="${lastCapsuleIndex}"]`).find(`input[value="${size}"]`).prop('checked', true).click().change()
      });
    }
    updateCapsulesIndex()
    calculatePrice()
    updateTilesPreview()
    saveBaSToSession()
    checkQuantity()
    generateDynamicBundleImage()
  }

  function removeCapsule(findLabel, findIsCustom, targetIndex) {
    const label = findLabel || selectedLabels[targetIndex].label || selectedLabels[targetIndex].customLabel
    const isCustom = findIsCustom || !!selectedLabels[targetIndex]?.customLabel
    const findedLabels = selectedLabels.filter((obj) => isCustom ? obj?.customLabel === label : obj?.label === label)
    if (!findedLabels.length) return

    const index = targetIndex || selectedLabels.indexOf(findedLabels[findedLabels.length - 1])
    const labelItem = $(`[data-label-name="${label}"]`, isCustom ? '.custom-label-list-wrapper' : '.bas-label-tab .label-list-wrapper')
    selectedLabels[index] = null
    labelItem.find('.count').text(findedLabels.length - 1)
    if (isCustom) labelItem.last().remove()
    if (findedLabels.length <= 1) labelItem.removeClass('active')
    $(`.bas-review-item[data-item-index="${index}"]`).remove()
    $(`.color-list-item[data-item-index="${index}"]`).remove()
    $(`.size-list-item[data-item-index="${index}"]`).remove()
    updateCapsulesIndex()
    calculatePrice()
    updateTilesPreview()
    saveBaSToSession()
    checkQuantity()
    generateDynamicBundleImage()
  }

  function addLabelToList(label, customLabel, isNew = true) {
    if (isNew) selectedLabels.push({ label, customLabel })
    const isCustom = !!customLabel
    if (isCustom) {
      const customLabelItem = $(`.custom-label-item-template`).clone().removeClass('custom-label-item-template').addClass('custom-label-item')
      customLabelItem.data('label-name', customLabel).attr('data-label-name', customLabel)
      customLabelItem.find('.label').text(customLabel)
      $('.custom-label-list-wrapper').append(customLabelItem)
      return
    }

    const labelItem = $(`.bas-label-tab .label-list-wrapper [data-label-name="${label}"]`)
    $countEl = labelItem.find('.count')
    const count = Number($countEl.text())
    $countEl.text(count + 1)
    labelItem.addClass('active')
  }

  function updateLabelInList(index, label, customLabel) {
    const old_label = selectedLabels[index].label || selectedLabels[index].customLabel
    const isCustom = !!selectedLabels[index]?.customLabel
    const labelItem = $(`[data-label-name="${old_label}"]`, isCustom ? '.custom-label-list-wrapper' : '.bas-label-tab .label-list-wrapper')
    const findedLabels = selectedLabels.filter((obj) => isCustom ? obj?.customLabel === old_label : obj?.label === old_label)
    labelItem.find('.count').text(findedLabels.length - 1)
    if (isCustom) labelItem.last().remove()
    if (findedLabels.length <= 1) labelItem.removeClass('active')
    selectedLabels[index].label = label
    selectedLabels[index].customLabel = customLabel
    addLabelToList(label, customLabel, false)
    $(`.bas-review-item[data-item-index="${index}"] .label`).html(getLabelHtml(label || customLabel))
    $(`.color-list-item[data-item-index="${index}"] .label`).html(getLabelHtml(label || customLabel))
    $(`.size-list-item[data-item-index="${index}"] .label`).html(getLabelHtml(label || customLabel))
    saveBaSToSession()
  }

  $('.delete-current-capsule').click(() => {
    $('.js-modal-open-bas-confirm-modal').click()
    $('#bas-confirm-modal .modal__centered-header').text(confirmDeleteTitle)
    $('#bas-confirm-modal .modal__centered-copy').text(confirmDeleteCopy).show()
    $('#bas-confirm-modal').data('type', 'bas-v2-delete')
    $('#bas-confirm-modal .btn-confirm').text('Remove')
  })

  $('#bas-confirm-modal .btn-confirm').click(() => {
    const { type } = $('#bas-confirm-modal').data()
    if (type !== "bas-v2-delete") return

    closeCurrentItem()
    removeCapsule('', '', editedCapsuleIndex)
    juni_event('bas-deleted', '', calculatePrice());
  })

  $('body').on('modalClose.bas-confirm-modal', () => {
    const { type } = $('#bas-confirm-modal').data()
    if (type !== "bas-v2-delete") return

    $('body').addClass('modal-open')
  });

  function moveSectionsToModal() {
    const $table = $('.bas-table').closest('.shopify-section')
    $('.new-bas-table').append($table.clone())
    $('.faq-section-build-a-system-table').append($table)
  }
  moveSectionsToModal()
  function moveCalculatorToModal() {
    const $table = $('#capacity-calculator').closest('.shopify-section')
    $('.new-bas-calculator').append($table)
  }
  moveCalculatorToModal()
  
  function updateCapsulesIndex() {
    const numberOfCapsules = $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)').length
    updateIndex = (i, el) => {
      const positions = numberOfCapsules >= listPositions.length ? listPositions[listPositions.length - 1] : listPositions[numberOfCapsules - 1]
      const index = numberOfCapsules >= positions.length ? positions[i] || i + 1 : i + 1
      $(el).find('.title .index').text(index)
      $(el).find('.title .index').data('index', i + 1)
    }
    $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)').each(updateIndex)
    $('.bas-color-tab-container .color-list-item').each(updateIndex)
    $('.bas-size-tab-container .size-list-item').each(updateIndex)
    
  }

  function closeCurrentItem() {
    $('body').removeClass('modal-open')
    $('.current-item').removeClass('active')
    $('.current-item').removeClass('is-new-capsule')
  }

  function defaultTooltipDescription(size) {
    if (size === 'Large') return 'The Large capsules holds up to 2.75 fl oz of product.'
    if (size === 'Medium') return 'The Medium capsules holds up to 1.32 fl oz of product.'
    return 'The Small holds up to .56 fl oz of product.'
  }

  function updateSizeTooltip(itemIndex) {
    const label = selectedLabels[itemIndex].label
    const size = capitalizeFirstLetter($(`.size-list-item[data-item-index="${itemIndex}"] input:checked`).val())
    const calcData = calculatorData.find((el) => el.product_type.toLowerCase().includes(label.toLowerCase().trim()))
    const tooltipText = calcData && calcData[size] ? calcData[size].description : defaultTooltipDescription(size)
    $(`.size-list-item[data-item-index="${itemIndex}"] .info-tooltip`).text(tooltipText)
  }

  function calculateCurrentItemPrice() {
    const size = capitalizeFirstLetter($(`.current-item .size-select input:checked`).val())
    const label = 'Shampoo' // it is not yet clear how the labels will be selected
    const isCustomize = false  // it is not yet clear how the labels will be selected
    const type = (isCustomize || isArakiIcon(label)) && size !== extenderName ? 'custom' : 'standard'
    const findOptionText = `${type} / ${size}`
    $('#ProductSelect option').toArray().find((option) => {
      const curOptionText = $(option).text()
      if (curOptionText.includes(findOptionText)) {
        $('.current-item-price').text(Number(curOptionText.match(/\$(.*?)USD/)[1]))
        return true
      }
    })
  }

  function updateSizesPreviews() {
    const color = $(`.current-item .color-select input:checked`).val()
    const $sizes = $('.current-item .size-select .size-select-item')

    $sizes.each((i, el) => {
      const size = $(el).attr('size')
      const $image = $(el).find('img')
      const colorIndex = bundleColorValues.indexOf(color) + 1
      $image.attr('src', `${image_service_dynacapsule}singles.php?is_single=true&capsules=${colorIndex}&size=${size.toLowerCase()}&cropped=true`)
      
      //DEVTODO- add the logic for the disabled sizes here, this is the last step in the review process

      // disabled the sizes based on disabledColorSizeArray
      if (
        (color in disabledColorSizeArray && disabledColorSizeArray[color]?.includes(capitalizeFirstLetter(size))) ||
        (color in outofStockColorArray && outofStockColorArray[color]?.includes(capitalizeFirstLetter(size))) 
        ) {
        $(el).addClass('disabled outofstock')
      }else{
        $(el).removeClass('disabled outofstock')
      }
    })
  }

  function calculatePrice() {
    let price = 0
    let capsule_count = 0
    let capsule_string = ''
    const items = $('.bas-review-item:not(.add-another-capsule)')
    items.map((i, el) => {
      const index = $(el).data('item-index')
      const size = capitalizeFirstLetter($(`.size-list-item[data-item-index="${index}"] input:checked`).val())
      const color = $(`.color-list-item[data-item-index="${index}"] input:checked`).val()
      
      const type = !!selectedLabels[index].customLabel ? 'custom' : 'standard'
      const findOptionText = `${type} / ${size}`
      
      // debugging

      capsule_count += 1
      if(isDebug){
        capsule_string += `${index}-${size}-${color} (${price});`;
        console.log(capsule_string)
      }

      $('#ProductSelect option').toArray().find((option) => {
        const curOptionText = $(option).text()
        if (curOptionText.includes(findOptionText)) {
          const variantPrice = curOptionText.match(/\$(.*?)USD/)
          if (variantPrice)
            price += Number(curOptionText.match(/\$(.*?)USD/)[1]);
            

            // increase the price by $2 if its renew
            if(color == 'Renew'){ 
              // if the size is medium then its 1 if the size is large then its 2
              // debugger;
              if(size == 'Large'){
                price += 2
              }else{
                price += 1 
              }
            }

          else
            $('.build-a-system-header .add-to-cart').removeClass('disabled')
          return true
        }
      })
    })
    
    if(isDebug){
      juni_event('debug-bas-string', capsule_string, capsule_count);
      console.log('debugging', {price}, {capsule_count})
    }

    const discountedPrice = calculateDiscountedPrice(price)
    checkDiscount(price)
    $('.product-content .cost').html(discountedPrice == price ? price : `${discountedPrice} <s>$${price}</s>`)
    $('.next-step-button, .product-content:not(:has(.button-start-building:visible)) .sticky-button').toggleClass('disabled', price <= 0 && !capsule_count)
    updateDiscountProgressBar(price)

    // BASAFFIRM
    if (typeof affirm !== 'undefined') {
      //set the data-amount attribute to the price
      if(affirm.jsReady()){
        $('.affirm-as-low-as').attr('data-amount', price * 100);
        affirm.ui.refresh();
      }
    }
    return price
  }

  function updateDiscountProgressBar(price) {
    if (updateDiscountProgressBarLoading || !startedBuilding) return

    const rule = [...BaSDiscountRules].reverse().find((curRule) => price < curRule.minPrice)
    const container = $('.discount-progress-wrapper')
    const lasTitle = $('.title:visible', container)
    const firstDiscount = $('.title.first-discount', container)
    const secondDiscount = $('.title.second-discount', container)
    const animationDelay = 500
    $('.title', container).hide()
    $('.progress', container).css('width', `${rule ? price / rule.minPrice * 100 : 100}%`)
    if (!rule) return $('.title.completed', container).show()

    $('.need-amount', container).text(rule.minPrice - price)
    if (BaSDiscountRules.indexOf(rule)) return firstDiscount.show()
    if (lasTitle.hasClass('first-discount')) {
      updateDiscountProgressBarLoading = true
      $('.progress', container).css('width', '100%').delay(animationDelay).queue((next) => {
        $('.progress', container).css('width', `${rule ? price / rule.minPrice * 100 : 100}%`)
        secondDiscount.show()
        updateDiscountProgressBarLoading = false
        next();
      });
      return
    }
    
    secondDiscount.show()
  }

  function calculateDiscountedPrice(price) {

    if(!cartRetrieved){
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // First store the raw value
          currentCartTotal = cart.original_total_price || 0;
          if (typeof currentCartTotal === 'number' && currentCartTotal > 0) {
            currentCartTotal = currentCartTotal / 100;
          }
          cartRetrieved = true;
        })
        .catch((error) => { currentCartTotal = 0; });
      }
    const rule = BaSDiscountRules.find((curRule) => price >= curRule.minPrice)
    
    // HOLIDAY2024TIERPRICING --------
    let pctg_discount = 1;
    let price_with_cart = price + currentCartTotal;

    // EARTHDAYROLLBACK
    // if (price_with_cart >= 300) pctg_discount = 0.8;
    // if (price_with_cart >= 200 && price_with_cart < 300) pctg_discount = 0.85;
    // if (price_with_cart >= 100 && price_with_cart < 200) pctg_discount = 0.9;
    //format as moneys to two decimal places, irregardless of how many cents it has 
    return (price * pctg_discount).toFixed(2);
    // END HOLIDAY PRICING STUFFS

    return rule ? price - rule.discount : price;
  }

  function checkDiscount(price) {
    if (price < priceToMaxDiscount) {
      $('.product-eyebrow .eyebrow-text').text(smallDiscountText)
    } else {
      $('.product-eyebrow .eyebrow-text').text(bigDiscountText)
    }
  }

  function updateTilesPreview() {
    $('.bas-tiles-preview-container').each((i, previewEl) => {
      const windowWidth = $(window).width()
      const previewWidth = $(previewEl).width()
      const labelSizeInPercent = 0.2533
      const labelImageSize = (windowWidth < previewWidth ? windowWidth : previewWidth) * labelSizeInPercent
      const colStep = labelImageSize * 0.87
      let row = col = 1
      topPosition = (row) => row * labelImageSize + (col % 2 ? 0 : labelImageSize / 2)
      leftPosition = (col) => col * colStep
      updateRowAndCol = (index) => {
        const presetPosition = firstPreviewPositions[index]
        if (presetPosition) {
          [col, row] = presetPosition
          return
        }

        const isTwoCapsuleCol = !(col % 2)

        if (isTwoCapsuleCol) {
          if (row === 1) {
            col += 1
            row = isTwoCapsuleCol ? 1 : 0
          } else row += 1
        } else {
          if (row === 1) row = 0
          else if (row === 2) {
            col += 1
            row = isTwoCapsuleCol ? 1 : 0
          }
          else row = 2
        }
      }
      $('.bas-tiles-preview-items div', previewEl).remove()
      const items = $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)')
      $('.bas-capsules-quantity .quantity').html(items.length)
      $('.bas-tiles-preview-container .placeholder').toggle(items.length <= 0)
      $('.bas-tiles-preview-container .bas-tiles-preview-items').toggle(items.length > 0)
      items.map((i, el) => {
        const index = $(el).data('item-index')
        const color = $(`.color-list-item[data-item-index="${index}"] input:checked`).val()
        const label = selectedLabels[index].label
        const customizeLabel = selectedLabels[index].customLabel
        var imageSrc = BaSLabelsPreviewImage[color]
        
        //check if the color image exists and is in master_color_list[color]?.previews?.['top']
        //NEW TOP IMAGES GO HERE
        if (color in master_color_list && master_color_list[color]?.previews?.['top']) {
          //if the image does not contain "no-image" on it, then use the imag
          if(master_color_list[color].previews['top'].indexOf('no-image') == -1){
            imageSrc = master_color_list[color].previews['top']
            // console.log('=== imageSrc', imageSrc)
            imageSrc = imageSrc.replace('//', 'https://')
          }
        }
        
        if(color == 'Renew' ){
          let rand_id = index % renewRandomImages['top'].length
          imageSrc = renewRandomImages['top'][rand_id]
        }
        
        if(color == 'Pearl'){
          let rand_id = index % pearlRandomImages['top'].length
          imageSrc = pearlRandomImages['top'][rand_id]
        }

        if(color == 'Granite'){
          let rand_id = index % graniteRandomImages['top'].length
          imageSrc = graniteRandomImages['top'][rand_id]
        }
        
        const labelHtml = isIcon(label) ? getLabelHtml(label) : parseLabel(customizeLabel || label)
        const colorIndex = colorNames.indexOf(color)
        const labelColor = labelColors[colorIndex]
        $('.bas-tiles-preview-items', previewEl).append(`
          <div class="bas-tiles-preview-item"  style="color: ${labelColor};left: ${leftPosition(col)}px; top: ${topPosition(row)}px">
            <img class="shadow" src="${BaSLabelsPreviewImage["SHADOW"]}" alt="label image - shadow">
            <img class="image" src="${imageSrc}" alt="label image - ${color}">
            <div class="label">${labelHtml.replace('-white.svg', `-${labelColor}.svg`).replace('-black.svg', `-${labelColor}.svg`)}</div>
          </div>`
        );
        $('.bas-tiles-preview-items', previewEl).css('width', (col + 2) * colStep)
        updateRowAndCol(i)
      })
    })

  }

  function loadProductFromUrl() {
    // let data = deparam(window.location.href.replace('?','?&'))
    let data = parameter_data;

    Object.keys(data).forEach(key => data[key.replace('amp;', '')] = data[key])
    
    if (!data['product_handle'] && !data['isEdit'] && !data['isPresetBuild']) {
      const savedUrl = localStorage.getItem('savedBas')
      data = deparam(savedUrl?.replace('?','?&'))
      if (!data['isEdit']) return
      data['isEdit'] = false
    }
    // debugger;

    if (data['isEdit']) {
      isEdit = true
      keyOfEdit = data['item_key']
      const addToCartEls = $('.add-to-cart')
      addToCartEls.html(addToCartEls.html().replace(addToCartButtonText, EditButtonText))
    }else if (data['isPresetBuild']) {
      // isEdit = true
      isPresetBuild = true
      keyOfEdit = data['item_key']
      console.log('isPresetBuild')
      $('.product-title').html('Customize your Bestseller Bundle')
      $('.main-product-copy').html('We\'ve prefilled the system builder with the labels from the Bestseller Bundle. Update individual colors and capsules to fit your needs!')
      if (data['productTitle']) {
        var productTitle = data['productTitle']
        $('.loader-text').html('Rebuilding '+productTitle+'')
        $('.product-title').html('Customize your '+productTitle+'')
        $('.main-product-copy').html('We\'ve prefilled the system builder with the labels from the '+productTitle+'. Update individual colors and capsules to fit your needs!')
      } 
    }
    
    const defaultColor = "Eucalyptus"
    const count = Number(basedOnProductMetafields?.cpsl_cnt || basedOnProductMetafields?.tile_cnt || data.count)
    const presetLabels = basedOnProductMetafields?.labels?.split(',') || data.bundleLabels
    const presetColors = basedOnProductMetafields?.colors?.split(',') || data.bundleColors
    const bundleCustomLabels = data.bundleCustomLabels
    const presetSizes = data.bundlesizes
    const selectizeOptions = Object.keys($('.premade-labels').eq(0).find('select').data('selectize').options)
    $('.shopify-section, #shopify-section-footer').show()
    clearAll()
    for (let i = 1; i <= count; i++) {
      const label = presetLabels ? selectizeOptions.find((option) => option.toLowerCase().trim() === presetLabels[i- 1].toLowerCase().trim()) || '' : ''
      const customLabel = bundleCustomLabels && bundleCustomLabels[i - 1]
      const color = presetColors && presetColors[i - 1].trim() || data.color || defaultColor
      const size = presetSizes ? presetSizes [i - 1]: BaSDefaultSize
      addCapsule(label.trim(), customLabel, color, size.toLowerCase())
    }
  }
  loadProductFromUrl()

  function openModal(modal, container) {
    // console.log('open modal');
    // console.log(modal.attr('class'));
    juni_event('bas-modal-open', modal.attr('class'));
    container.removeClass('active')
    modal.click()
    container.addClass('active')
  }
  
  $('[data-label-preview]').click(function() {
    openModal($('.js-modal-open-bas-recommended-bundles'), $('#bas-recommended-bundles .modal__inner'))
  });

  $('[data-table-preview]').click(function() {
    openModal($('.js-modal-open-bas-table-preview'), $('#bas-table-preview .modal__inner'))
  });

  $('[data-color-filter]').click(function() {
    openModal($('.js-modal-open-bas-color-filter'), $('#bas-color-filter .modal__inner'))
    $('#bas-color-filter .custom-home-shop-itemColorButton.color7PM').click()
  });


  $('#bas-color-filter .custom-home-shop-itemColorButton').click(function() {
    const color = $(this).attr('data-color-value')
    $('#bas-color-filter .custom-home-shop-itemColorButton').removeClass('active');
    $(this).addClass('active');
    $('#bas-color-filter .images').removeClass('active');
    $(`#bas-color-filter [data-selected-color-${color}]`).addClass('active')
    $('#bas-color-filter .color_value').html(`${color}`)
  })

  function chunkArray(array, chunkSize) {
    const result = [];
  
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      result.push(chunk);
    }
  
    return result;
  }

  function generateDynamicBundleImage() {
    const tileGroupSize = 14
    const leftOffset = isDesktop() ? 115 : 83
    const groupWidth = isDesktop() ? 140 : 100
    const stackedImageProp = {
      Small: 'smallStacked',
      Tile: 'tileStacked'
    }
    const allItems = $('.bas-review-tab-container .bas-review-item:not(.add-another-capsule)').map((i, el) => {
      const index = $(el).data('item-index')
      const label = selectedLabels[index].label
      const customizeLabel = selectedLabels[index].customLabel
      const color = $(`.color-list-item[data-item-index="${index}"] input:checked`).val()
      const size = capitalizeFirstLetter($(`.size-list-item[data-item-index="${index}"] input:checked`).val())
      return {
        index,
        label,
        customizeLabel,
        color,
        size
      }
    })
    
    const items = allItems.filter((el) => el.size !== tileName) // remove the tiles and move all small capsules to the end of the array
    const tileItems = allItems.filter((el) => el.size === tileName) // tiles only
    const groups = chunkArray(tileItems, tileGroupSize);

    $('.dynamic-bundling-container').html('')
    for (let i = 0; i < items.length; i++) {
      const currItem = items[i]
      groups.push([currItem])
    }
    const tiles = groups.filter(group => group[0].size === 'Tile')  
  
    const filtredGtoups = groups.filter(group => group[0].size !== 'Tile')
    filtredGtoups.push(...tiles)
    filtredGtoups.forEach((el, i) => {
      const groupEl = $('<div class="group"></div>')
      const positions = allItems.length >= listPositions.length ? listPositions[listPositions.length - 1] : listPositions[allItems.length - 1]
      const position = allItems.length >= positions.length && positions[i] ? positions[i] - 1 : i
      groupEl.css('z-index', groups.length - position + 1 )
      groupEl.css('left', position * leftOffset)
      el.forEach((groupItem, i) => {
        const imgType = i > 0 && el.length > 1 ? stackedImageProp[groupItem.size] : groupItem.size.toLowerCase()
        let imgUrl = dynamicBundlingImages[imgType][groupItem.color?.toLowerCase()]
        
        let cap_size = groupItem.size?.toLowerCase();
        // 
        //METAIMAGING
        if(groupItem.color && imgType){  
          imgUrl = master_color_list[groupItem.color]?.previews?.[imgType]
        }

        if(groupItem.color == 'Renew' ){
          let rand_id = position % renewRandomImages[cap_size].length
          imgUrl = renewRandomImages[cap_size][rand_id]
        }

        if(groupItem.color == 'Pearl'){
          let rand_id = position % pearlRandomImages[cap_size].length
          imgUrl = pearlRandomImages[cap_size][rand_id]
        }
        if(groupItem.color == 'Granite'){
          let rand_id = position % graniteRandomImages[cap_size].length
          imgUrl = graniteRandomImages[cap_size][rand_id]
        }        

        //add the groupItem.color to the groupelclassname
        if(groupItem.color){
          groupEl.addClass('dynamicgroup-'+groupItem.color.toLowerCase())
        }
        groupEl.append(`<img class="${groupItem.size}" src="${imgUrl}" alt="Dynamic Bundle Image">`)
      })
      $('.dynamic-bundling-container').append(groupEl)
    })
    $('.dynamic-bundling-container').css('width', leftOffset * (groups.length - 1) +  groupWidth)
    $('.dynamic-bundling-container').append(`<img class="backlight" src="${dynamicBundlingImages.backlight}" alt="Dynamic Bundle Backlight">`)
    $('.dynamic-bundling-container').append(`<img class="shadow" src="${dynamicBundlingImages.shadow}" alt="Dynamic Bundle Shadow">`)
  }
  generateDynamicBundleImage()

  function saveBaSToSession() {
    if (!startedBuilding) return

    localStorage.setItem('savedBas', saveBaSToUrl())
  }
  $('.button-start-building').removeClass('disabled')
  juni_event('bas-loaded', '', calculatePrice());
  if(isPresetBuild){
    //moving on to next step
    // console.log('isPresetBuild moving to subsequent step')
    $('.product-content .next-step-button:visible, .product-content .button-start-building:visible').first().click()
    $('.product-content .next-step-button:visible, .product-content .button-start-building:visible').first().click()
    $('.main-product-copy').show()
    //wait two seconds
    setTimeout(function(){
      //click on the add to cart button
      $('body').removeClass('unloading');
    }, 2000);

  }
  
})

$('#bas-table-preview .menu_item').click(function() {
  $('#bas-table-preview .window').removeClass('active')
  $('#bas-table-preview .menu_item').removeClass('active')
  $(this).addClass('active')
  $(`#${$(this).attr('data-modal')}`).addClass('active')
})

function checkActiveColor(activeColor) {
  $('.settings .label-image .image').removeClass('active')
  if (activeColor) {
    $(`.settings [data-color-variant="${activeColor}"]`).addClass('active')
    return
  }

  const color = $('.variant-input-wrap input:checked').val()
  $(`.settings [data-color-variant="${color}"]`).addClass('active')
}

$('.settings .variant-input').click(function() {
  // console.log('checking active color')
  checkActiveColor($(this).attr('data-value'))
})
